import { Component, OnDestroy, OnInit } from '@angular/core'
import { createPackage, Package } from '../../models/package.model'
import { Subscription } from 'rxjs'
import { PackageService } from '../../services/package.service'
import { SharedService } from 'src/app/shared/services/shared.service'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { ToastrService } from 'ngx-toastr'
import { environment } from 'src/environments/environment'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import * as moment from 'moment'

@Component({
	selector: 'app-add-package',
	templateUrl: './add-package.component.html',
	styleUrls: ['./add-package.component.scss'],
})
export class AddPackageComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	packageData: Package = new createPackage()
	breadCrumbRout: any
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	isEditMode: boolean = false
	attachmentPath = environment.attachmentPath
	addServiceMode = false
	viewMode = true
	isFormValid: boolean[] = [false, false, false]
	id: number = 0
	timeDifference: number = 0
	timeLeft: any = {
		days: 0,
		hours: 0,
		min: 0,
		sec: 0,
	}

	constructor(
		private packageService: PackageService,
		private activeRout: ActivatedRoute,
		public translate: TranslateService,
		private SharedService: SharedService,
		private toaster: ToastrService,
		private dialog: MatDialog,
		private router: Router
	) {}

	ngOnInit(): void {
		this.packageData.branchId = this.activeRout.snapshot.queryParams['branchId']
		if (this.activeRout.snapshot.params['id']) {
			const id = this.activeRout.snapshot.params['id']
			this.id = this.activeRout.snapshot.params['id']
			this.getPackage(id)

			this.isEditMode = true
		}
		this.SharedService.handleBreadCrumb(
			!this.isEditMode ? 'ADD_PACKAGE' : 'EDIT_PACKAGE',
			false,
			{
				name: '',
				id: null,
				url: '',
				queryParams: null,
			}
		)
	}

	updateForm(data: any) {
		this.calculateTimeLeft(this.packageData?.endDate)
		this.packageData = { ...this.packageData, ...data?.value }
		this.isFormValid[data?.index] = data?.isValid

		if (data?.isSave) {
			this.createPackage(true)

			data.isSave = false
		}
	}

	getPackage(id: number) {
		this.subscription.add(
			this.packageService.getPackage(id).subscribe((res: any) => {
				this.packageData = res.result
				this.calculateTimeLeft(this.packageData?.endDate)
			})
		)
	}

	uploadImg() {
		this.dialog
			.open(UploadImageComponent, {
				width: '752px',
				panelClass: 'overflow-y-auto',
				data: this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.packageService
								.uploadPackageImg(body)
								.subscribe((res: any) => {
									this.packageData.image = res?.result?.url
									this.isEditMode ? this.createPackage(this.isEditMode) : ''
								})
						)
					}
				},
			})
	}

	deleteImg() {
		this.packageData.image = ''
		this.isEditMode ? this.createPackage(true) : ''
	}

	navigate() {
		this.router.navigate(
			['layout/service-providers/organization-profile/packages'],
			{
				queryParams: {
					branchId: this.packageData?.branchId,
				},
			}
		)
	}

	createPackage(reload?: boolean) {
		this.packageData.packageServices.forEach((ele) => {
			ele.discountAmount = 0
		})
		this.subscription.add(
			this.getApi().subscribe({
				complete: () => {
					!reload ? this.navigate() : this.getPackage(this.id)
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
				},
			})
		)
	}

	getApi() {
		return !this.isEditMode
			? this.packageService.createPackage(this.packageData)
			: this.packageService.editPackage(this.packageData)
	}

	calculateTimeLeft(endDate: any) {
		const endMoment = moment.utc(endDate).endOf('day') // Set endDate to the end of the day
		const currentMoment = moment()
		let localEndMoment = endMoment
		// Check if endDate is today
		if (currentMoment.isSame(endMoment, 'day')) {
			// Set localEndMoment to the end of the day if endDate is today
			localEndMoment = currentMoment.clone().endOf('day')
		}
		this.timeDifference = localEndMoment.diff(currentMoment)
		if (this.timeDifference > 0) {
			this.timeLeft = {}
			this.timeLeft['days'] = localEndMoment.diff(currentMoment, 'days')
			this.timeLeft['hours'] =
				(localEndMoment.diff(currentMoment, 'hours') % 24) - 2
			this.timeLeft['min'] = localEndMoment.diff(currentMoment, 'minutes') % 60
			this.timeLeft['sec'] = localEndMoment.diff(currentMoment, 'seconds') % 60
		} else {
			this.timeLeft = { days: 0, hours: 0, min: 0, sec: 0 }
		}
	}

	confirmAction(toggleName: string, event: any, currentStatus: boolean) {
		event.source.checked = currentStatus

		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',

				data: {
					image: 'assets/images/repeat.svg',
					notflex: true,

					message: this.translate.instant(
						toggleName == 'isActive'
							? 'CONFIRMATION_MESSAGE.CHANGE_ACTIVATION_STATUS'
							: 'CONFIRMATION_MESSAGE.CHANGE_BOOKING_ABILITY'
					),
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						if (toggleName == 'isActive') {
							this.packageData.isActive = !event.source.checked
							!this.packageData?.isActive
								? (this.packageData.canBook = false)
								: ''
							this.isEditMode ? this.createPackage(true) : ''
						}
						if (toggleName == 'canBook') {
							this.packageData.canBook = !event.source.checked
							this.isEditMode ? this.createPackage(true) : ''
						}
					}
				},
			})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
